import { Loader } from 'google-maps'
import Vue from 'vue'
// import '../vue/vee-validate'

import ContactForm from '../vue/components/ContactForm.vue'

export default {
  init() {
    const loader = new Loader('AIzaSyAmzVRyvmH3uOwrVu982cOhVDBKC4Tv120', {
      libraries: ['places'],
      map_ids: '122e2f349bf66ad8',
      // language: SNP.lang,
      // region: 'JP',
    })
    const lat = 13.620538635939614
    const lng = 100.64053701365508
    new Vue({
      el: '.contact-form',
      components: { ContactForm },
    })

    loader.load().then(function (google) {
      const map = new google.maps.Map(document.querySelector('.contact-map'), {
        center: { lat, lng },
        zoom: 19,
        mapTypeControl: false,
        streetViewControl: false,
        // scrollwheel: false,
        mapId: '122e2f349bf66ad8',
        zoomControl: false,
      })

      const marker = new google.maps.Marker({
        map,
        draggable: false,
        // icon: UGO.marker,
        position: { lat, lng },
      })

      google.maps.event.addListener(marker, 'click', () => {
        window.open('https://maps.app.goo.gl/wedsSxwupXGnsQrh9')
      })
    })
  },
  finalize() {},
}
